export default function WhyBluPoint() {
  const pillars = [
    {
      icon: 'ri-heart-line',
      label: 'OUR PHILOSOPHY',
      title: 'Cleaning With Purpose, Not Just Process',
      body: `At Blu-Point, we believe that a truly clean environment goes beyond surface appearances. Our philosophy is rooted in the idea that every space we service reflects the people who work and live in it. We don't show up with a checklist — we show up with a commitment to doing the job right, every single time. We take pride in understanding each client's unique environment and delivering results that speak for themselves. Consistency, integrity, and attention to detail are not just words to us — they are the standard we hold ourselves to at every building, without exception.`,
      bg: 'bg-gray-900',
      text: 'text-white',
      bodyText: 'text-gray-300',
      labelBg: 'bg-teal-500 text-gray-900',
      accent: 'text-teal-400',
    },
    {
      icon: 'ri-building-2-line',
      label: 'OUR BACKGROUND',
      title: 'Built by Property Owners for Property Owners',
      body: `Our perspective is different because of our background as commercial property owners and operators. We understand the needs of owners and managers who take pride in their buildings. Whether you own a single retail strip or manage a portfolio of office and industrial, we tailor our service to protect your investment and keep your tenants satisfied.\n\nOur local presence means we are always nearby, always reachable, and always ready to step in when something needs attention. No runaround. No corporate delays. Just a reliable local partner who shows up and gets it done.`,
      bg: 'bg-teal-600',
      text: 'text-white',
      bodyText: 'text-teal-50',
      labelBg: 'bg-white text-teal-700',
      accent: 'text-white',
    },
    {
      icon: 'ri-team-line',
      label: 'OUR PEOPLE',
      title: 'We Invest in the People Who Do the Work',
      body: `The quality of our service is a direct reflection of how we treat our employees. At Blu-Point, we believe that a supported, well compensated, and respected workforce delivers better results — and we have built our company around that belief. Our team members receive proper training, respectful treatment, and a management team that listens. We do not rely on high turnover and constant replacement. We invest in retention because experienced, familiar faces build trust with our clients. When our employees feel valued, they take ownership of their work — and that makes all the difference in the quality you receive.`,
      bg: 'bg-white',
      text: 'text-gray-900',
      bodyText: 'text-gray-600',
      labelBg: 'bg-teal-100 text-teal-800',
      accent: 'text-teal-600',
    },
  ];

  return (
    <section id="testimonials" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <i className="ri-shield-check-line text-teal-600 text-xl"></i>
            <span className="text-sm font-semibold tracking-widest text-gray-500 uppercase">Why Blu-Point</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-4">What Sets Us Apart</h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto leading-relaxed">
            We are not the biggest cleaning company — and that is intentional. We are built to be the best partner for the clients we serve, grounded in values that drive every decision we make.
          </p>
        </div>

        {/* Three Pillars */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {pillars.map((pillar, index) => (
            <div key={index} className={`${pillar.bg} rounded-3xl p-8 flex flex-col`}>
              <span className={`inline-block ${pillar.labelBg} px-4 py-1.5 rounded-full text-xs font-semibold mb-6 self-start`}>
                {pillar.label}
              </span>
              <div className={`w-12 h-12 flex items-center justify-center mb-4`}>
                <i className={`${pillar.icon} text-3xl ${pillar.accent}`}></i>
              </div>
              <h3 className={`text-xl font-bold ${pillar.text} mb-4 leading-snug`}>{pillar.title}</h3>
              <p className={`text-sm leading-relaxed ${pillar.bodyText}`}>{pillar.body}</p>
            </div>
          ))}
        </div>

        {/* Bottom Banner */}
        <div className="relative rounded-3xl overflow-hidden min-h-72">
          <img
            src="https://public.readdy.ai/ai/img_res/050f4008008762f90c704d1b2229fd1e.jpg"
            alt="Blu-Point Team"
            className="w-full h-full object-cover object-top absolute inset-0"
          />
        </div>

      </div>
    </section>
  );
}
